<template>
  <!-- 基础选择页面 -->
  <XModal ref="modal" class="select-modal height-limit-dialog dialog-p0" :title="'选择' + title" width="70%" :ok="ok">
    <div class="flex h100 ">
      <div v-if="hasTree" class="tree-container br1 flex flex-column">
        <div class="title"><AIcon class="mr5" type="share-alt" />{{title}}目录</div>
        <YScroll class="flex1" :padding="0">
          <ATree :key="`tree-${treeKey}`" default-expand-all :treeData="treeData" :replaceFields="replaceFields" blockNode 
            @select="nodeClick" selectedKeys.sync="selectedKeys"
          />
        </YScroll>
      </div>
      <div class="flex1 flex flex-column">
        <Search :search-data="searchParams" :search-item="searchItem" @search="searchList"></Search>
        <div class="flex1">
          <XTable 
            :key="`table-${tableKey}`"
            ref="xtable" 
            :columns="columns"
            :data-api="pageDataApi" 
            :select-type="selectType" 
            :paging-type="2"
            :pageSize="20"
            :params="params"
          />
        </div>
      </div>
    </div>
  </XModal>
</template>
<script>
export default {
  props: {
    /** 列表接口方法 */
    treeDataApi: Function,
    /** 树节点参数名称 */
    nodeParamKey: {
      type: String,
      default: 'parentNodeId'
    },
    /** 表格数据方法 */
    pageDataApi: {
      type: Function,
      require: true
    },
    /** 表格字段配置 */
    columns: {
      type: Array,
      require: true
    },
    /** 标题名称 */
    title: {
      require: true
    },
    /** 查询条件 */
    searchParams: {
      type: Object,
      require: true
    },
    /** 查询表单配置 */
    searchItem: {
      type: Array,
      require: true
    },
    /** 选择项类型 */
    selectType: {
      default: 'checkbox'
    }
  },
  data() {
    return {
      treeData: [],
      // 树状图属性对应配置
      replaceFields: {
        title: 'name'
      },
      currTreeId: null,
      treeKey: 0,
      tableKey: 0
    };
  },
  computed:{
    // 是否存在树目录
    hasTree(){
      return this.treeDataApi != null
    },
    // 列表查询参数
    params(){
      let params = {...this.searchParams}
      if(this.hasTree){
        params[this.nodeParamKey] = this.currTreeId
      }
      return params
    }
  },
  created(){
  },
  mounted(){
  },
  methods:{
    async open(){
      this.loadTreeData()
      this.tableKey++
      // this.searchList()
      this.$refs.modal.open()
    },
    // 加载树节点数据
    async loadTreeData(){
      if(!this.hasTree) return
      const {data} = await this.treeDataApi()
      this.treeData = data
      this.resetTree()
    },
    // 重置树
    resetTree(){
      //重置搜索
      this.currTreeId = null
      this.treeKey++
    },
    // 搜索列表数据
    async searchList(reset){
      if(reset){
        this.resetTree()
      }
      this.$nextTick(function(){
        this.$refs.xtable && this.$refs.xtable.searchList()
      })
    },
    //点击树节点
    async nodeClick(selectedKeys, {node}){
      const nodeId = node.dataRef.id
      if(nodeId == this.currTreeId){
        return
      }
      this.currTreeId = nodeId
      this.searchList()
    },
    // 确定
    ok(){
      const selectionData = this.$refs.xtable.getSelectionData()
      this.$emit("selected", selectionData)
      this.$refs.modal.cancel()
    },
  },
  watch:{
  }
};
</script>
<style lang="less" scoped>
.select-modal{
  .tree-container{
    min-width: 20%;
    max-width: 30%;
  }
  .title{
    border-bottom: solid 1px @border;
    padding: 5px 10px;
    font-size: 16px;
    font-weight: bold;
    /deep/ .anticon{
      color: @primary
    }
  }
}
/deep/ .ant-tree{
  width: -webkit-fill-available;
}
</style>
